import moment from 'moment';

import * as appConstants from '../constants';

export const tradesSelectedAreDifferent = (firstList, secondList) => {
    if (firstList.length !== secondList.length) {
        return true;
    }
    for (let x = 0; x < firstList.length; x++) {
        if (firstList[x].selected !== secondList[x].selected) {
            return true;
        }
    }
    return false;
};

export const lastWorkingDay = () => {
    const now = moment();
    const day = now.day();
    const subtraction = (day === 0 && 2) || (day === 1 && 3) || 1;
    return now.subtract(subtraction, 'days').format('YYYYMMDD');
};

export const createGridSort = (sorts, gridId) => [{ gridId, gridSort: sorts }];

export const findGridSort = (sorts, gridId) => {
    const defaultSort = sorts.find(x => x.gridId === gridId);
    if (defaultSort && defaultSort.gridSort) {
        return defaultSort.gridSort;
    }
    return [];
};

export const getVirtualDirectory = () => {
    const virtualDirectory = (window.APP_ENV_CONFIG && window.APP_ENV_CONFIG.APP_VIRTUAL_DIR) || '/';
    return `${!virtualDirectory.startsWith('/') ? '/' : ''}${virtualDirectory}`;
};

export const usageHasBeenAgreedToday = (lastAgreementDate, currentDate) => {
    if (!lastAgreementDate || !currentDate) {
        return false;
    }
    const previousDate = moment(lastAgreementDate, appConstants.dateFormat).toDate();
    const newDate = moment(currentDate, appConstants.dateFormat).toDate();
    if (newDate.getFullYear() === previousDate.getFullYear()
        && newDate.getMonth() === previousDate.getMonth()
        && newDate.getDate() === previousDate.getDate()) {
        return true;
    }
    return false;
};
